import React from "react"
import styled from "styled-components"
import device from "@utils/device"

import { Container, Title } from "@components/style"
import { IconFacebook, IconYoutube, IconInstagram } from "@components/icons"

// import ContactForm from '../contact-form'
import { graphql, StaticQuery, useStaticQuery } from "gatsby"
import BgImage from "../bgImage"
import StyledBackgroundSection from "../bgImage"
// import { BackgroundImage } from "../style"

const Link = styled.a`
  font-family: 'georgia';
  color: #fff;
  text-decoration: none;
  font-size: 1rem;
  line-height: 1.8rem;
  font-weight: 500;
  margin-bottom: 0.8rem;

  @media ${device.tablet} {
    font-size: 1.2rem;
    line-height: 1.5rem;
  }
  
  &:hover {
    text-decoration: ${props => props.a ? "underline" : "none"};
  }
`

const Line = styled.hr`
  width: 150px;
  width: 280px;
  border-bottom: 1px solid #fff;
  margin: 40px 0;
`

const Social = styled.span`
  margin-bottom: 64px;
`

const Contact = () => (
  <StaticQuery
    query={graphql`
      query {
        bgImage: file(relativePath: { eq: "contact-bg.jpg" }) {
          childImageSharp {
            fluid(quality: 90, maxWidth: 1920) {
                ...GatsbyImageSharpFluid_withWebp
            }
          }
        }
      }
    `}
    render={data => (
      <StyledBackgroundSection image={data.bgImage.childImageSharp.fluid}>
        <Container>
          <Title>Skontaktuj się z nami</Title>
            <Link a href="mailto:lukasgabriel.prd@gmail.com">lukasgabriel.prd@gmail.com</Link>
            <Link a href="tel:+48881704040">+48 881 70 40 40</Link>
            <Link span>KRAKÓW/POLSKA</Link>
          <Line />

          <Social>
            <IconFacebook />
            <IconYoutube />
            <IconInstagram />
          </Social>
        </Container>
      </StyledBackgroundSection>
    )}
  />
)

export default Contact
